import "./WebsiteForCoachesAndConsultants.module.css";
import Header from "@/reusable_sections/Header";
import KhatVongDanDau from "./sections/KhatVongDanDau";
import WhyChooseOurVenues from "./sections/WhyChooseOurVenues";
import EngineAnimation from "./sections/EngineAnimation";
import OurPromise from "./sections/OurPromise";
import BeispielMockup from "./sections/BeispielMockup";
import ServicePackages from "./sections/ServicePackages";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import BackupSolutions from "./sections/BackupSolutions";
import Footer from "@/reusable_sections/Footer";
export default function WebsiteForCoachesAndConsultantsPage() {
  return <div>
      <Header />
      <KhatVongDanDau />
      <WhyChooseOurVenues />
      <EngineAnimation />
      <OurPromise />
      <BeispielMockup />
      <ServicePackages />
      <CustomerTestimonials />
      <BackupSolutions />
      <Footer />
    </div>;
}